<script setup lang="ts">
import { computed } from 'vue';
import type { IColumnDefinition, RowData, IDateColumn } from '../types';

const props = defineProps<{
  value: any;
  row: RowData;
  column: IColumnDefinition;
}>();

const col = computed(() => props.column as IDateColumn);

const locale = computed(() => {
  return (window as any).$app?.i18n?.locale || navigator.language || 'en';
});

const formattedDate = computed(() => {
  if (!props.value) {
    return '';
  }

  const date = new Date(props.value);
  if (isNaN(date.getTime())) {
    return props.value;
  }

  return date.toLocaleDateString(locale.value);
});
</script>

<template>
  <span class="text-nowrap">{{ formattedDate }}</span>
</template>
